<div class="pt-page">
  <!-- Week day chip strip -->
  <div class="pt-week-row">
    <ng-container *ngIf="!loading">
      <div class="pt-day-chip" *ngFor="let d of weekDays"
           [class.active]="selectedDay.dayName === d.dayName"
           [class.is-today]="d.isToday && selectedDay.dayName !== d.dayName"
           (click)="selectDay(d)">
        <span class="pt-day-name">{{ d.shortLabel }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="loading">
      <div class="pt-day-chip pt-skeleton" *ngFor="let i of [1,2,3,4,5,6,7]"></div>
    </ng-container>
  </div>

  <!-- Loading skeleton -->
  <div class="pt-timeline-scroll" *ngIf="loading">
    <div class="pt-skeleton pt-skeleton-row" *ngFor="let i of [1,2,3,4,5,6]"></div>
  </div>

  <!-- Error -->
  <div class="pt-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i>
    {{ 'unableToLoadTimetableTryAgain' | translate }}
  </div>

  <!-- Not configured -->
  <div class="pt-empty-state" *ngIf="!loading && !loadError && !isConfigured">
    <i class="ri-calendar-line"></i>
    {{ 'staffTimetableNotConfigured' | translate }}
  </div>

  <!-- Timeline -->
  <ng-container *ngIf="!loading && !loadError && isConfigured">
    <div class="pt-empty-state pt-empty-state-day" *ngIf="!periods.length">
      <i class="ri-calendar-line"></i>
      {{ 'noTimetableForThisDay' | translate }}
    </div>

    <div class="pt-timeline-scroll" id="pt-timeline-scroll">
      <div class="pt-timeline" [style.height.px]="totalHeight">
        <!-- Hour grid -->
        <div class="pt-hour-row" *ngFor="let top of hourTops; let i = index" [style.top.px]="top">
          <span class="pt-hour-label" *ngIf="i < 24">{{ hourLabel(i) }}</span>
          <div class="pt-hour-line"></div>
        </div>

        <!-- Now line -->
        <div class="pt-now-line" *ngIf="showNowLine" [style.top.px]="nowOffset">
          <span class="pt-now-badge">{{ currentTimeLabel }}</span>
        </div>

        <!-- Period cards -->
        <div class="pt-period-card"
             *ngFor="let p of periods"
             [class.is-break]="p.isBreak"
             [class.is-past]="isPast(p)"
             [class.is-current]="isCurrent(p)"
             [style.top.px]="p.top"
             [style.height.px]="p.height"
             [style.left]="'calc(56px + (100% - 68px) * ' + (p.left / 100) + ')'"
             [style.width]="'calc((100% - 68px) * ' + (p.width / 100) + ')'">
          <div class="pt-period-time">
            <i class="ri-time-line" *ngIf="p.isBreak"></i>
            {{ p.periodStart }} - {{ p.periodEnd }}
          </div>
          <div class="pt-period-title">{{ p.title }}</div>
          <div class="pt-period-subtitle" *ngIf="p.subtitle">{{ p.subtitle }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
